/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import { createApp } from 'vue';

/**
 * Load the vue date time picker
 */
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

// Load event emitter
import mitt from 'mitt';
const emitter = mitt();

/**
 * Next, we will create a fresh Vue application instance. You may then begin
 * registering components with the application instance so they are ready
 * to use in your application's views. An example is included for you.
 */
const app = createApp({});

/**
 * Define global functions and properties here
 *
 */
app.config.globalProperties.$notification = (type, message) => {
    $.toast({
        heading: type.toUpperCase(),
        text: message,
        icon: type,
        showHideTransition: 'slide',
        position: 'top-right',
        hideAfter: 5000,
        stack: false
    })
};

app.config.globalProperties.$emitter = emitter;

/**
 * Create a global function to truncate string
 */
app.config.globalProperties.$truncateString = (str, maxLength) => {
    if (str && str.length > maxLength) {
        return str.substring(0, maxLength) + '...';
    }
    return str;
};

// Define base URL
app.config.globalProperties.$baseUrl = window.baseUrl;

// Define global date time format function
import moment from "moment";

app.config.globalProperties.$moment = (date, format = null) => {
    if (format) {
        return moment(date, format);
    }
    return moment(date);
};

// Define global date time format function
// Format date and time using
app.config.globalProperties.$dateTimeFormat = (date, format) => {
    return moment(date).format(format);
};


/**
 * Capitalize first letter of each word in a string
 */
app.config.globalProperties.$capitalize = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

// Go to the page
app.config.globalProperties.$goToPage = (url, newTab = false) => {
    if (newTab) {
        window.open(url, '_blank');
        return;
    }
    else {
        window.location.href = url;
    }
};

// import ExampleComponent from './components/ExampleComponent.vue';
//app.component('example-component', ExampleComponent);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Load the vue date time picker component
 */
app.component('VueDatePicker', VueDatePicker);

// Include the vee-validate plugin
import { Field, Form, ErrorMessage, defineRule, configure } from 'vee-validate';
import { all } from '@vee-validate/rules';

// Dynamically define all rules
Object.entries(all).forEach(([name, rule]) => {
    defineRule(name, rule);
});

configure({
    validateOnInput: true,
    generateMessage: (context) => {
        const messages = {
            required: 'This field is required',
            email: 'Please enter a valid email address',
            url: 'Please enter a valid URL',
            min: `The field must be at least ${context.rule.params[0]} characters`,
            numeric: `The field ${(context.field).replace(/_/g, ' ')} must be a number.`,
            min_value: `The field ${(context.field).replace(/_/g, ' ')} must be at least ${context.rule.params[0]}.`,
        };
        return messages[context.rule.name] || `The field ${(context.field).replace(/_/g, ' ')} is invalid`;
    },
});

app.component('Form', Form);
app.component('Field', Field);
app.component('ErrorMessage', ErrorMessage);


/**
 * Load the vue multiselect component
 */
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css';
app.component('vue-multiselect', Multiselect);

// Load the vue easy data table component
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
app.component('Vue3EasyDataTable', Vue3EasyDataTable);

// Load the vuex store
import store from './store/store';
app.use(store);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
app.mount('#app');
